"use strict";

/**
 * Predictive search
 */
let search_details = document.querySelector('.search-container');
if(search_details) {
	search_details.addEventListener('toggle', () => {
		if(search_details.open) {
			search_details.querySelector('input[name="q"]').focus();
		}
	});
}

let search_debounce = false;
document.querySelectorAll('.predictive-search input[name="q"]').forEach(input => input.addEventListener('input', e => {
	const input = e.target;
	const form = input.closest('form');

	if(search_debounce) clearTimeout(search_debounce);
	search_debounce = setTimeout(() => run_predictive_search(input.value, form), 200);
}));

async function run_predictive_search(searchTerm, form) {
	if(searchTerm.trim() == '') {
		form.querySelector('.predictive-search__results').innerHTML = '';
		return;
	}

	let response = await fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)

	if (!response.ok) {
		throw new Error(response.status);
	}

	let text = await response.text();

	const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
	form.querySelector('.predictive-search__results').innerHTML = resultsMarkup;
}

/**
 * Events
 */

let price_throttle = false;
window.addEventListener('input', e => {
	if(e.target.classList.contains('field__input')) {
		const section = e.target.closest('.shopify-section');

		if(!section) return;
		
		if(price_throttle !== false) clearTimeout(price_throttle);
		price_throttle = setTimeout(() => {
			run_filters(section)
		}, 700);
	}
});

window.addEventListener('click', e => {
	if(e.target.closest('.product-card__link')) {
		const card = e.target.closest('.product-card');
		if(!card) return;

		const url = new URL(location.href);
		const params = url.searchParams;
		params.set('page', card.dataset.page);
		url.search = params.toString();
		url.hash = card.getAttribute('id');

		history.pushState({}, '', url.toString());
	} else if(e.target.classList.contains('product-option__input')) {
		update_product_variant(e.target.closest('.product-options__container'));
	} if(e.target.classList.contains('filter-checkbox')) {
		const section = e.target.closest('.shopify-section');
		if(section) run_filters(section);
	} else if(e.target.classList.contains('button--remove-filter')) {
		e.preventDefault();

		const section = e.target.closest('.shopify-section');
		const url = e.target.getAttribute('href');

		update_collection(section, url);
	} else if(e.target.classList.contains('qty-btn')) {
		const input = e.target.closest('.qty-selector').querySelector('input');
		let qty = Number(input.value);
		if(isNaN(qty)) return false;

		if( e.target.classList.contains('qty-btn--less') ) qty--;
		else qty++;

		if(qty < input.min) qty = input.min;

		input.value = qty;

		input.dispatchEvent(new Event('input', {bubbles: true}));
	} else if(e.target.classList.contains('product-option__more-link')) {
		e.preventDefault();
		const option_list = e.target.closest('.product-option__list');

		if(!option_list) return;

		option_list.classList.toggle('product-option__list--expanded');
	} else if(e.target.classList.contains('line-item__remove')) {
		const line_item = e.target.closest('.cart__line-item');
		if(!line_item) return;
		
		e.preventDefault();
		const index = line_item.getAttribute('data-index');

		_change_item_qty(index, 0, response => {
			_update_cart_sections(response.sections);
		});
	} else if(e.target.classList.contains('collection-products__more-btn')) {
		e.preventDefault();

		const section = e.target.closest('.shopify-section');
		history.pushState({}, '', e.target.getAttribute('href'));
		run_filters(section, e.target.closest('.collection-products__more-btn').getAttribute('data-page'));
	} else if(e.target.classList.contains('collection-products__restart-btn')) {
		e.preventDefault();

		const section = e.target.closest('.shopify-section');
		history.replaceState({}, '', e.target.getAttribute('href'));
		run_filters(section);
	} else if(e.target.classList.contains('collection-products__prev-btn')) {
		e.preventDefault();

		const section = e.target.closest('.shopify-section');
		history.pushState({}, '', e.target.getAttribute('href'));
		run_filters(section, e.target.closest('.collection-products__prev-btn').getAttribute('data-page'), true);
	}
});

if(document.querySelector('.collection-products__restart')) {
	document.querySelector('.collection-products__restart').scrollIntoView();
}

window.addEventListener('input', e => {
	if(e.target.name == 'updates[]') {
		const line_item = e.target.closest('.cart__line-item');
		if(!line_item) return;

		const index = line_item.getAttribute('data-index');
		const qty = e.target.value;

		_change_item_qty(index, qty, response => {
			_update_cart_sections(response.sections);
		});
	}
}, true);


async function set_sl_price(target) {
	if(target.dataset.sku) {
		const response = await window.spark.calculatePricingForVariant(target.dataset.productId, target.dataset.sku, 1, 1);
		if(response.unitPrice) {
			target.textContent = `$${response.unitPrice.toFixed(2)}`;
		}
		return;
	} else if(target.dataset.productId) {
		const response = await window.spark.getProduct(target.dataset.productId);
		let min_price = 0;
		let max_price = 0;

		response.variants.forEach(variant => {
			if(variant.price) {
				if(min_price == 0 || variant.price.net < min_price) min_price = variant.price.net;
				if(max_price == 0 || variant.price.net > max_price) max_price = variant.price.net;
			}
		});

		if(min_price != max_price) {
			target.textContent = `$${min_price.toFixed(2)} - $${max_price.toFixed(2)}`;
			// document.querySelector(`.sl_price[data-product-id="${target.dataset.productId}"]:not([data-sku])`).forEach(inp => inp.textContent = `$${min_price.toFixed(2)} - $${max_price.toFixed(2)}`);
		} else {
			target.textContent = `$${min_price.toFixed(2)}`;
			// document.querySelector(`.sl_price[data-product-id="${target.dataset.productId}"]:not([data-sku])`).forEach(inp => inp.textContent = `$${min_price.toFixed(2)}`);
		}

		return;
	} else {
		console.log('Failed to get price');
	}
}

let price_observer = new IntersectionObserver(
	function (entries) {
		entries.forEach((entry) => {
			if (entry.intersectionRatio > 0) {
				// price_observer.unobserve(entry.target);
				entry.target.classList.add('sl_price--loaded');
				set_sl_price(entry.target);
			}
		});
	},
	{
		threshold: 0.1,
		rootMargin: "0%"
	}
);

document.addEventListener('spark-is-ready', () => {
	setTimeout(() => {
		document.querySelectorAll('.sl_price:not(.sl_price--loaded)').forEach(pr => set_sl_price(pr));
	}, 300)

	const sl_prices = document.querySelectorAll(".shopify-product-form:not(.slider__slide) .sl_price");
	sl_prices.forEach(price => {
		price_observer.observe(price);
	});

	document.querySelectorAll('.slider--product-slider').forEach(slider => {
		let scrolling_price_observer = new IntersectionObserver(
			function (entries) {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0) {
						scrolling_price_observer.unobserve(entry.target);
						set_sl_price(entry.target);
						entry.target.classList.add('sl_price--loaded');
					}
				});
			},
			{
				root: slider,
				threshold: 0.1,
				rootMargin: "0%"
			}
		);

		let prices = slider.querySelectorAll('.sl_price');
		prices.forEach(price => {
			scrolling_price_observer.observe(price);
		});
	});
});

/**
 * Collections
 */
const collection_products_more = document.querySelector(".collection-products__more-btn");

let collection_pagination_observer = new IntersectionObserver(
	function (entries) {
		entries.forEach((entry) => {
			if (entry.intersectionRatio > 0) {
				entry.target.click();
			}
		});
	},
	{ threshold: 0, rootMargin: "50%" }
);

if(collection_products_more) collection_pagination_observer.observe(collection_products_more);

async function update_collection(section, url) {
	const container_id = section.getAttribute('id');
	const section_id = container_id.replace('shopify-section-', '');
	const filters_toggle_state = section.querySelector('.collection-container--filters-toggle');

	history.pushState({}, '', url);

	section.classList.add('section-loading');
	if(url.indexOf('?') > -1) url += `&section_id=${section_id}`;
	else url += `?section_id=${section_id}`;
	let response = await fetch(url);

	response = await response.text();

	if(filters_toggle_state) {
		response = response.replace('collection-container', 'collection-container collection-container--filters-toggle');
	}

	section.outerHTML = response;

	section.querySelectorAll('.products__grid .sl_price').forEach(price => {

		set_sl_price(price);
	});

	document.querySelector(`#shopify-section-${section_id}`).querySelectorAll('.product-options__container').forEach(check_product_options_availability);
}

async function run_filters(section, paginate = false, back = false) {
	const container_id = section.getAttribute('id');
	const section_id = container_id.replace('shopify-section-', '');
	const form = section.querySelector('.collection-filters-form');
	const filters_toggle_state = section.querySelector('.collection-container--filters-toggle');

	let formData, url;
	if(form) {
		url = form.getAttribute('action');
		formData = new FormData(form);
	} else {
		url = window.location.pathname;
		formData = new FormData();
	}

	const sortSelect = section.querySelector('.sort-filter-select');
	if(sortSelect) {
		formData.append('sort_by', sortSelect.value);
	}

	history.pushState({}, '', url + "?" + new URLSearchParams(formData));

	if(paginate !== false) {
		formData.append('page', paginate);
	} else {
		section.classList.add('section-loading');
	}

	formData.append('section_id', section_id);

	let response = await fetch(url + "?" + new URLSearchParams(formData));

	response = await response.text();

	if(filters_toggle_state) {
		response = response.replace('collection-container', 'collection-container collection-container--filters-toggle');
	}

	if(paginate !== false) {
		const parser = new DOMParser();
		const html = parser.parseFromString(response, "text/html");

		if(back) {
			section.querySelector('.products__grid').innerHTML = html.querySelector('.products__grid').innerHTML + section.querySelector('.products__grid').innerHTML;
		} else {
			section.querySelector('.products__grid').innerHTML += html.querySelector('.products__grid').innerHTML;
		}
		// section.classList.remove('section-loading');

		if(back) {
			const restart = html.querySelector('.collection-products__restart');
			if(restart) {
				section.querySelector('.collection-products__restart').innerHTML = restart.innerHTML;
			} else {
				section.querySelector('.collection-products__restart').remove();
			}
		} else {

			const more = html.querySelector('.collection-products__more');
			if(more) {
				section.querySelector('.collection-products__more').innerHTML = more.innerHTML;
				collection_pagination_observer.observe(section.querySelector('.collection-products__more-btn'));
			} else {
				section.querySelector('.collection-products__more').remove();
			}
		}
	} else {
		section.outerHTML = response;

		section = document.querySelector(`#shopify-section-${section_id}`);

		section.querySelectorAll('.product-options__container').forEach(check_product_options_availability);

		const more_btn = section.querySelector('.collection-products__more-btn');
		if(more_btn) collection_pagination_observer.observe(more_btn);
	}

	section.querySelectorAll('.products__grid .sl_price').forEach(price => {
		// price_observer.observe(price);

		set_sl_price(price);
	});
}

window.addEventListener('change', async e => {
	if(e.target.classList.contains('sort-filter-select')) {
		const select = e.target;
		const section = select.closest('.shopify-section');
		run_filters(section);
	}
});


/**
 * Products
 */

document.querySelectorAll('.product-options__container').forEach(check_product_options_availability);

document.querySelectorAll('.button--open-list').forEach(btn => btn.addEventListener('click', e => {

	const container = document.querySelector('.shopify-product-form .product-form__block--options');
	let spark = document.querySelector('.shopify-product-form spark-pdp').shadowRoot;
	if(spark) {
		const product_options = container.querySelectorAll('.product-option');
		let selector_array = [];
		product_options.forEach(product_option => {
			let checked_option = product_option.querySelector('[type="radio"]:checked');

			let spark_select = spark.querySelector(`select[name="${product_option.dataset.name}"]`);
			if(spark_select) {
				spark_select.value = checked_option.value;
				spark_select.dispatchEvent(new Event('change', {bubbles: true}));
			} else if(product_option.dataset.name == 'Color') {
				const this_li = checked_option.closest('li');
				const index = [...this_li.parentElement.children].indexOf(this_li);

				spark.querySelectorAll('input[type="number"]').forEach(inp => {
					inp.value = 0;
					inp.dispatchEvent(new Event('change', {bubbles: true}))
				});
				spark.querySelectorAll('input[type="number"]')[index].value = container.closest('.shopify-product-form').querySelector('.product-form__block--add-to-cart .quantity__input').value;
				spark.querySelectorAll('input[type="number"]')[index].dispatchEvent(new Event('change', {bubbles: true}));
			}
		});

		setTimeout(() => {
			spark.querySelector('button[aria-label="Add to shopping list"]').click()
		}, 10);
	}
}));

window.addEventListener('submit', async e => {
	if(e.target.classList.contains('shopify-product-form')) {
		e.preventDefault();
		const form = e.target;
		if(!form) return;

		form.classList.add('product-form-loading');

		const currentCart = await window.spark.getCart();
		// const existingItems = currentCart?.items || [];
		
		const select = form.querySelector('.product-variants-select');
		const sku = select.options[select.selectedIndex].dataset.sku;
		const products = [];

		const options_table = form.querySelector('.product-form__block--options .product-option__table');
		if(options_table) {
			options_table.querySelectorAll('[data-sku]').forEach(product => {
				let qty = Number(product.value);
				if(!isNaN(qty) && qty > 0) {

					// let existingProduct = existingItems.find(item => item.sku === product.dataset.sku);
					// if(existingProduct) qty += existingProduct.quantity;

					products.push({sku: product.dataset.sku, adjustQuantity: qty
						// customAttributes: [
						// {
						// 	'key': 'variation',
						// 	'value': select.options[select.selectedIndex].textContent
						// }
						// ]
					});
				}
			});
		} else {
			let qty = Number(form.querySelector('.product-form__block--add-to-cart .quantity__input').value);

			if(!isNaN(qty) && qty > 0) {
				// let existingProduct = existingItems.find(item => item.sku === sku);
				// if(existingProduct) qty += existingProduct.quantity;

				products.push({
					sku,
					adjustQuantity: qty,
					// customAttributes: [
					// 	{
					// 		"key": "note",
					// 		"value": "Lorem ipsum dolor"
					// 	}
					// ]
				});
			}
		}

		form.querySelectorAll('.product-addon[open]').forEach(addon => {
			let qty = Number(addon.querySelector('.quantity__input').value);
			if(!isNaN(qty) && qty > 0) {
				const select = addon.querySelector('.product-variants-select');
				let addon_sku = select.options[select.selectedIndex].dataset.sku;

				// let existingProduct = existingItems.find(item => item.sku === addon_sku);
				// if(existingProduct) qty += existingProduct.quantity;
				
				products.push({sku: addon_sku, adjustQuantity: qty,
					// customAttributes: [
					// {
					// 	'key': 'variation',
					// 	'value': select.options[select.selectedIndex].textContent
					// }
					// ]
				});
			}
		});

		console.log(products);
		await window.spark.updateCart({products});

		form.classList.remove('product-form-loading');
		openCart();
		return;

		const formData = new FormData(form);

		form.classList.add('product-form-loading');
		await fetch(Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			body: formData
		})
		.then(response => {
			return response.json()
		})
		.then(data => {
			// data.quantity
			const messages = form.querySelector('.product-messages');
			if(data.status == 422) {
				if( messages ) {
					messages.innerHTML = data.message;
				}

				return;
			}

			if( messages ) messages.innerHTML = '';
		})
		.catch(error => {
			console.log('Error:', error);
		});

		form.classList.remove('product-form-loading');
	} else if(e.target.classList.contains('collection-filters-form')) {
		e.preventDefault();

		run_filters(e.target.closest('.shopify-section'));
	}
});

function check_product_options_availability(product) {
	let selector_values = [];

	product.querySelectorAll('.product-option').forEach((product_option, index) => {
		const position = Number(product_option.getAttribute('data-position')) - 1;
		const checked = product_option.querySelector('[type="radio"]:checked');
		if(checked) {
			selector_values[position] = checked.value;
		}
	});

	product.querySelectorAll('.product-option').forEach((product_option, index) => {
		const container = product_option.closest('.product-options__container');
		if(!container) return;

		const select = container.querySelector('.product-variants-select');
		if(!select) return;
		
		const position = Number(product_option.getAttribute('data-position'));

		product_option.querySelectorAll('.product-option__value').forEach(option => {
			const value = option.querySelector('[type="radio"]').value;

			if( position > 1 ) {
				let selector = 'option';
				for( let i = 1; i <= selector_values.length; i++ ) {
					if( i == position ) selector += `[data-option-${i}="${CSS.escape(value)}"]`;
					else selector += `[data-option-${i}="${CSS.escape(selector_values[i - 1])}"]`;
				}

				if( !select.querySelector(selector) ) {
					option.classList.add('product-option__value--hidden');
					// console.log('Hiding', selector);
				} else {
					option.classList.remove('product-option__value--hidden');
					// console.log('Showing', selector);
				}
			}

			if(select.querySelector(`option[data-option-${position}="${CSS.escape(value)}"][data-available="true"]`)) {
				option.classList.remove('product-option__value--na');
			} else option.classList.add('product-option__value--na');
		});

		if(!product_option.querySelector('.product-option__value:not(.product-option__value--hidden), .product-option__table')) {
			product_option.setAttribute('hidden', 'hidden');
		} else product_option.removeAttribute('hidden');
	});
}

async function load_product_options(form, variant_id, url = false) {
	const options = form.querySelector('.product-options__container');
	if(options) {
		options.classList.add('product-options__container--loading');
		if(!url) url = window.location.pathname + `?variant=${variant_id}&section_id=product-options`;

		let response = await fetch(url);
		response = await response.text();

		options.outerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;

		form.querySelectorAll('.product-options__container .sl_price').forEach(price => price_observer.observe(price));

		count_product_qty({target: form});
		if(form.classList.contains('shopify-product-form')) form = form.querySelector('.product-form__block--options');
		check_product_options_availability(form);
	}
}

async function load_product_attributes(form, variant_id) {
	const attributes = form.querySelector('.product-attributes');
	if(attributes) {
		attributes.classList.add('product-attributes--loading');
		const url = window.location.pathname + `?variant=${variant_id}&section_id=product-info`;

		let response = await fetch(url);
		response = await response.text();

		attributes.outerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
	}
}

async function load_product_gallery(section, form, variant_id) {
	const gallery = section.querySelector('.product-media__container');
	if(gallery) {
		gallery.classList.add('product-media__container--loading');
		const url = window.location.pathname + `?variant=${variant_id}&section_id=product-gallery`;

		let response = await fetch(url);
		response = await response.text();

		gallery.outerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
		gallery.classList.remove('product-media__container--loading');
		setTimeout(() => {
			section.querySelector('.product-media__container').querySelectorAll('.slider').forEach(slider => checkSlider(slider));
			activate_zoom(section.querySelector('.product-media__container'));
			activate_dots(section.querySelectorAll(".slider__wrapper .slider__dot, .slider .slider__dot, [nav-for] > .slider__dot"))
		}, 10);
	}

	setTimeout(() => {
		const thumb = form.closest('.shopify-section--product').querySelector(`.product-thumbnails [data-variant~="${variant_id}"]`);
		if(thumb) thumb.click();
	}, 15);
}

async function update_product_variant(container) {
	const select = container.querySelector('.product-variants-select');
	const form = container.closest('.product-addon, .shopify-product-form');
	let selector = 'option';

	const product_options = container.querySelectorAll('.product-option');
	let selector_array = [];
	product_options.forEach(product_option => {
		const position = product_option.getAttribute('data-position');
		let checked_option = product_option.querySelector('[type="radio"]:checked');

		if(checked_option && checked_option.closest('.product-option__value').classList.contains('product-option__value--hidden')) {
			checked_option = product_option.querySelector('.product-option__value:not(.product-option__value--hidden) [type="radio"]');
			if(checked_option) checked_option.checked = true;
		}

		if(!checked_option) return;

		const value = checked_option.value;
		const selected_value = product_option.querySelector('.selected-value');
		if(selected_value) selected_value.textContent = value;

		selector += `[data-option-${position}="${CSS.escape(value)}"]`;
		selector_array.unshift(selector);
	});

	let option;
	for(let i = 0; i < selector_array.length; i++) {
		option = select.querySelector(selector_array[i]);
		if(option) break;
	}
	// select.value = option.value;
	const variant_id = option.value;

	const price_container = form.querySelector('.product-price');
	if(price_container) {
		price_container.innerHTML = `<div class="sl_price" data-product-id="${select.dataset.productId}" data-sku="${option.dataset.sku}"></div>`;

		set_sl_price(price_container.querySelector('.sl_price'));
	}

	if(form.querySelector('.add-to-cart-button')) {
		if( option.getAttribute('data-available') == 'false' ) {
			form.classList.add('product-unavailable');
			form.querySelector('.add-to-cart-button').disabled = true;
		} else {
			form.classList.remove('product-unavailable');
			form.querySelector('.add-to-cart-button').disabled = false;
		}
	}

	if(form.closest('.shopify-section--product') && !form.closest('.product-addon')) {
		const section = form.closest('.shopify-section--product');
		history.pushState({}, '', `?variant=${variant_id}`);

		load_product_gallery(section, form, variant_id);
		load_product_attributes(form, variant_id);
		load_product_options(form, variant_id);
	} else if(form.closest('.product-addon')) {
		const url = `/products/${form.closest('.product-addon').dataset.handle}?variant=${variant_id}&section_id=product-options`;
		load_product_options(form, variant_id, url);
	} else {
		const image = option.getAttribute('data-image');
		if(image) form.querySelector('.product-card__image img')?.setAttribute('srcset', image);

		const price = form.querySelector('.sl_price');
		if(price) {
			price.dataset.sku = option.dataset.sku;

			set_sl_price(price);
		}

		form.querySelectorAll('.product-card__link').forEach(link => {
			let href = link.getAttribute('href');
			href = href.split('variant=');
			link.setAttribute('href', `${href[0]}variant=${variant_id}`);
		});
	}

	select.value = variant_id;
}

/**
 * Mobile menu
 */
let aninmating_menu = false;
const menu_animation_time = 300;
document.querySelectorAll('.show-submenu').forEach(btn => btn.addEventListener('click', e => {
	e.preventDefault();
	if(aninmating_menu) return;

	const submenu = e.target.closest('.sub-menu__item');

	if(submenu) {
		const currently_active = e.target.closest('.sub-menu').querySelector('.sub-menu__item--active');
		if(currently_active && currently_active != submenu) currently_active.classList.remove('sub-menu__item--active');
		submenu.classList.toggle('sub-menu__item--active');
		return;
	}

	const item = e.target.closest('.menu__item');
	if(item) item.classList.add('menu__item--active');

	const menu = e.target.closest('.menu');
	if(!menu) return;

	aninmating_menu = true;

	menu.style.setProperty('--level', '1');

	setTimeout(() => {
		aninmating_menu = false;
	}, menu_animation_time);
}));

document.querySelectorAll('.menu-back').forEach(btn => btn.addEventListener('click', e => {
	e.preventDefault();
	if(aninmating_menu) return;

	const menu = e.target.closest('.menu');
	if(!menu) return;

	const item = e.target.closest('.menu__item');
	
	aninmating_menu = true;
	menu.style.setProperty('--level', '0');

	setTimeout(() => {
		if(item) item.classList.remove('menu__item--active');
		aninmating_menu = false;
	}, menu_animation_time);
}));


/**
 * ADDONS
 */
document.querySelectorAll(".product-addon__button").forEach(addon_button => addon_button.addEventListener('click', count_product_qty));

document.querySelectorAll('.shopify-section--product .qty-selector input').forEach(qty => qty.addEventListener('input', count_product_qty));

document.querySelectorAll('.product-addon').forEach(addon => {
	addon.addEventListener('input', e => {
		count_product_qty(e);
	});
});

function count_product_qty(evt) {
	const container = evt.target.closest('.shopify-section--product');

	let original_qty = container.querySelector('.product-form__block--add-to-cart .qty-selector input');
	if(original_qty) original_qty = Number(original_qty.value);
	else original_qty = 0;

	setTimeout( () => {
		const added_addons = container.querySelectorAll('.product-addon[open]');
		const disabled_addons = container.querySelectorAll('.product-addon:not([open])');

		disabled_addons.forEach(addon => {
			addon.querySelector('.product-variants-select').disabled = true;
			addon.querySelector('.qty-selector input').disabled = true;
			addon.querySelector('[data-product-qty]').setAttribute('name', 'properties[qg_additional_products_off]')
		});

		let count_qty = 0;
		added_addons.forEach(added_addon => {
			added_addon.querySelector('.product-variants-select').disabled = false;
			added_addon.querySelector('.qty-selector input').disabled = false;

			added_addon.querySelectorAll('.qty-selector input').forEach(inp => {
				const addon_qty = Number(inp.value);
				count_qty += addon_qty;
			});
			// added_addon.querySelector('[data-product-qty]').setAttribute('name', 'properties[qg_additional_products]');
			// added_addon.querySelector('[data-product-qty]').setAttribute('data-product-qty', addon_qty);
		});

		container.querySelectorAll('.product-count').forEach(c => {
			if(added_addons.length > 0) {

				count_qty += original_qty;

				if(!isNaN(count_qty))
					c.textContent = count_qty;
				else c.innerHTML = '';
			} else c.innerHTML = '';
		});
	}, 0);
}

/**
 * Cart functions
 */
function _change_item_qty(line, qty, callback, always) {
	if(typeof always != 'function') always = () => {};

	fetch(window.Shopify.routes.root + 'cart/change.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			line: line,
			quantity: qty,
			sections: `${cart_section_id}`
		})
	})
	.then(response => {
		if(!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

		return response.json();
	})
	.then(response => {
		if(typeof callback == 'function') callback(response);
	})
	.catch((error) => {
		console.error('Error:', error);
	})
	.then(always, always);
}

function _update_cart_sections(sections) {
	document.querySelector('.shopify-section--cart').outerHTML = sections[cart_section_id];
}

let cart_section_id;
if(document.querySelector('.shopify-section--cart')) {
	cart_section_id = document.querySelector('.shopify-section--cart').getAttribute('id').replace('shopify-section-', '');
}

function activate_zoom(parent = document) {
	parent.querySelectorAll('.image:has(.image-zoom)').forEach(zoom => {
		zoom.addEventListener('click', e => {
			const img = e.target.closest('.image');
			if(!img) return;

			// const container = img.querySelector('.image-zoom__container');
			const container = document.querySelector('#gallery-zoom');
			// const rect = img.getBoundingClientRect();

			const thumbs = document.querySelector('.gallery-zoom__thumbs');
			const all_images = e.target.closest('.product-images').querySelectorAll('.image .image-zoom');

			if(!container) return;

			const imgzoomed = img.querySelector('.image-zoom').cloneNode();

			const zoomed_container = document.querySelector('#gallery-zoom .gallery-zoom__image');

			// img.classList.toggle('image--zoomed');
			zoomed_container.innerHTML = '';
			zoomed_container.append(imgzoomed);

			thumbs.innerHTML = '';
			all_images.forEach(thumb => {
				let new_thumb = thumb.cloneNode();
				if(new_thumb.getAttribute('src') == imgzoomed.getAttribute('src')) new_thumb.classList.add('image-zoom--current');
				thumbs.append(new_thumb);
			});

			thumbs.querySelectorAll('.image-zoom').forEach(img => img.addEventListener('click', e => {
				thumbs.querySelector('.image-zoom--current').classList.remove('image-zoom--current');
				
				const imgzoomed = e.target.cloneNode();
				
				zoomed_container.innerHTML = '';
				zoomed_container.append(imgzoomed);

				e.target.classList.add('image-zoom--current');
			}));

			
			document.querySelector('#gallery-zoom').showModal();

			const zoomed_rect = zoomed_container.getBoundingClientRect();
			container.scrollTop = zoomed_rect.height / 2;//(container.scrollHeight - rect.height) * e.offsetY / rect.height;
			container.scrollLeft = 0;//(container.scrollWidth - rect.width) * e.offsetX / rect.width;
		});

		// zoom.addEventListener('mousemove', e => {
		// 	const img = e.target.closest('.image');
		// 	if(!img) return;
			
		// 	const rect = img.getBoundingClientRect();
		// 	const x = e.offsetX * 100 / rect.width;
		// 	const y = e.offsetY * 100 / rect.height;

		// 	img.style.setProperty('--zoom-x', x + '%');
		// 	img.style.setProperty('--zoom-y', y + '%');
		// });
	});
}

activate_zoom();


// addEventListener('click', e => {
// 	if(e.target.closest('.wfq-quote-btn-selected')) {
// 		setTimeout(() => {
// 			document.querySelector('#wfq-floatingicon-mid-right').click()
// 		}, 100);
// 	}
// });

function injectFormStyles() {
const formEmbed = document.querySelector('#app-embed'); // Find the form container
if (formEmbed && formEmbed.shadowRoot) {
	const style = document.createElement('style');
	style.textContent = `
	input,
	textarea,
	button {
		border-radius: 0 !important;
	}
		input[type="email"],
		input[type="tel"],
		input[type="number"],
		textarea,
		.phone-country-selector > *,
	input[type="text"] {
	box-shadow: none !important;
		border: 1px solid #556289 !important;
	}
		[data-sizing="form-wrapper"] {
			max-width: 900px !important;
			margin: 0 auto;
			font-family: Mulish !important;
		}
			[data-sizing="form-wrapper"] form {
			display: flex;
			flex-direction: row !important;
			flex-wrap: wrap;
		}

		[data-sizing="form-wrapper"] form > fieldset {
			flex: 0 0 100%;
		}

		[data-sizing="form-wrapper"] form > fieldset:has(label:only-child) legend {
			display: none;
		}

		[data-sizing="form-wrapper"] form button[class*="_selectToggle"] {
			box-shadow: 0 0 0 1px #556289;
			max-height: none;
		}

		[data-sizing="form-wrapper"] form [class*="_selectContainer"] {
			position: relative;

			& > p {
				position: absolute;
				top: 1.25rem;
				padding: 0;
				left: 1.5rem;
				color: var(--form-placeholder-color);
				z-index: 2;
				transition: top 0.4s, font-size 0.4s;
			}

			&:has([class*="_selectToggleText"]:not(:empty)) > p,
			&:has([aria-expanded="true"]) > p {
				font-size: 1em;
				top: 0.25rem;
			}

			[class*="_selectToggleText"] {
				translate: 0 5px;
			}
		}

		[data-sizing="form-wrapper"] form {
			align-items: flex-end;
		}
		[data-sizing="form-wrapper"] form > :not([class]) {
			position: absolute;
			z-index: -1;
		}

		output[role="alert"] {
			display: none !important;
		}

		form fieldset:has(output) label {
	border: 1px solid red !important;
	outline: 1px solid red !important;
}

		form > div:has(+ output ) {
input[type="email"],
		input[type="tel"],
		input[type="number"],
		textarea,
		.phone-country-selector > *,
	input[type="text"] {
	border-color: red !important;
	outline: 1px solid red !important;
}
		}


		[data-sizing="form-wrapper"] form  > * {
	flex: 1;
	min-width: 320px;
}

	[data-sizing="form-wrapper"] div:empty {
	display: none;
}

[data-sizing="form-wrapper"] form > button {
	flex: 0 0 100%;
}

	[data-sizing="form-wrapper"] form > div:has(textarea),
	[data-sizing="form-wrapper"] form > div:has(button:not([type="button"])) {
		&::before {
	display: none;
	}
		flex: 0 0 100%;
		grid-column: 1 / -1;
}
	`;
	formEmbed.shadowRoot.appendChild(style);
}
}

// Use MutationObserver to ensure the script runs after the form loads
const observer = new MutationObserver((mutations) => {
for (const mutation of mutations) {
	if (mutation.addedNodes.length) {
	injectFormStyles();
	}
}
});

// Start observing the document body for changes
observer.observe(document.body, { childList: true, subtree: true });

// Also try running once immediately
injectFormStyles();

document.querySelector('.account-link--slide')?.addEventListener('click', e => {
	spark.openDrawer('account');
	setTimeout( () => {
		document.querySelector('spark-drawer').shadowRoot.querySelector('header nav button').style.display = 'none';
		
		// document.querySelector('spark-drawer').shadowRoot.querySelectorAll('button').forEach(btn => btn.addEventListener('click', e => {
		// 	document.querySelector('spark-drawer').shadowRoot.querySelectorAll('button').forEach(btn => {
		// 		if(btn.textContent.includes('Assigned to me')) {
		// 			console.log(btn);
		// 			btn.click();
		// 			btn.previousElementSibling.style.display = "none";
		// 			return;
		// 		}
		// 	});
		// }));

		document.querySelector('spark-drawer').shadowRoot.addEventListener('click', e => {
			const path = e.composedPath();

			document.querySelector('spark-drawer').shadowRoot.querySelectorAll('button').forEach(btn => {
				if(btn.textContent.includes('Assigned to me')) {
					btn.classList.add('assigned-to-me');
				}
			});

            setTimeout(() => {
              const eq = document.querySelector('spark-drawer').shadowRoot.querySelector('[aria-label="Edit Quote"]');
              if(eq) eq.parentElement.parentElement.style.display = 'none';

			  if(path[0].closest('button') && !path[0].closest('button').textContent.includes('Assigned to me')) {
				let nope = false;
				path[0].parentElement.querySelectorAll('button').forEach(btn => {
					if(btn.textContent.includes('Assigned to me')) {
						nope = true;
					}
				});

				document.querySelector('spark-drawer').shadowRoot.querySelectorAll('button').forEach(btn => {
					if(btn.textContent.includes('Assigned to me')) {
						if(!nope) {
							btn.classList.add('assigned-to-me');
							btn.closest('section').classList.add('the-section');
							btn.closest('section').querySelector('table').style.opacity = '0.3';
							btn.closest('section').querySelector('header').innerHTML += '<style>.the-section div:has(> button) > :first-child{display: none}</style>';
							// setTimeout( () => {
							// 	btn.click();
							// 	const theClick = new MouseEvent('click');
							// 	btn.dispatchEvent(theClick);
							// 	btn.previousElementSibling.style.display = "none";
							// }, 500);

							setTimeout( () => {
								btn.click();
								const theClick = new MouseEvent('click');
								btn.dispatchEvent(theClick);

								setTimeout(() => {
									btn.closest('section').querySelector('table').style.opacity = '1';
									btn.previousElementSibling.style.display = "none";
								}, 200);
							}, 1500);
						}
						btn.previousElementSibling.style.display = "none";
						return;
					}
				});
			  }
            }, 50);
		});
	}, 100);
});

function debounce(mainFunction, delay) {
	let timer;

	return function (...args) {
		clearTimeout(timer);

		timer = setTimeout(() => {
			mainFunction.apply(this, args);
		}, delay);
	};
}